import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { FaTrash, FaTimes } from 'react-icons/fa';
import { deleteUserAccount } from '../utils/deleteAccount';
import './DeleteAccountModal.css';

const DeleteAccountModal = ({ onClose, onDeleted }) => {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  const handleDelete = async () => {
    setDeleting(true);
    setError('');
    try {
      await deleteUserAccount();
      onDeleted?.();
    } catch (e) {
      setError(e.message || 'Failed to delete account');
    } finally {
      setDeleting(false);
    }
  };

  const modal = (
    <div className="delete-account-overlay" onClick={onClose} role="presentation">
      <div
        className="delete-account-modal"
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-labelledby="delete-account-title"
        aria-describedby="delete-account-desc"
      >
        <button
          type="button"
          className="delete-account-close"
          onClick={onClose}
          aria-label="Close"
          disabled={deleting}
        >
          <FaTimes aria-hidden />
        </button>

        <div className="delete-account-icon" aria-hidden>
          <FaTrash />
        </div>

        <h3 id="delete-account-title">Delete my account</h3>
        <p id="delete-account-desc" className="delete-account-desc">
          This will permanently delete your account and everything you added — all your properties,
          meeting spaces, bookings, saved stays, messages, reviews, and other app activity.
          This cannot be undone.
        </p>

        {error ? <p className="delete-account-error">{error}</p> : null}

        <div className="delete-account-actions">
          <button
            type="button"
            className="delete-account-cancel"
            onClick={onClose}
            disabled={deleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="delete-account-confirm"
            onClick={handleDelete}
            disabled={deleting}
          >
            {deleting ? 'Deleting...' : 'Delete my account'}
          </button>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return modal;
  return ReactDOM.createPortal(modal, document.body);
};

export default DeleteAccountModal;
